var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitPlan.MSVNumber"),
                                    prop: "msvNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.msvNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "msvNo",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.msvNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitPlan.Year"),
                                    prop: "Year",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "year",
                                      clearable: "",
                                      "value-format": "yyyy",
                                      placeholder: "选择年",
                                    },
                                    model: {
                                      value: _vm.queryCondition.year,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "year",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.year",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitPlan.Type"),
                                    prop: "type",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      on: { change: _vm.typeChange },
                                      model: {
                                        value: _vm.queryCondition.type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "type",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.typeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.chineseValue,
                                            value: item.code,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitPlan.Category"),
                                    prop: "category",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      on: { change: _vm.CategoryChange },
                                      model: {
                                        value: _vm.queryCondition.category,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "category",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.category",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.NAME,
                                            value: item.NAME,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "visitPlan.SupplierFacility"
                                            ),
                                            prop: "tmSupplierId",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              on: {
                                                clear: _vm.clearSupplierName,
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .supplierName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "supplierName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.supplierName",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-search",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.searchSupplier()
                                                  },
                                                },
                                                slot: "append",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "visitPlan.ReportStatus"
                                            ),
                                            prop: "status",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.status",
                                              },
                                            },
                                            _vm._l(
                                              _vm.MSVStatusList,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.chineseValue,
                                                    value: item.code,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "创建时间(从)",
                                            prop: "createQueryBeginData",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .createQueryBeginData,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createQueryBeginData",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createQueryBeginData",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "创建时间(至)",
                                            prop: "createQueryEndData",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .createQueryEndData,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createQueryEndData",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createQueryEndData",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "visitPlan.CreateUser"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition.creater,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "creater",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.creater",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-search",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.searchCreateBy()
                                                  },
                                                },
                                                slot: "append",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "拜访日期(从)",
                                            prop: "visitBeginDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .visitBeginDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "visitBeginDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.visitBeginDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "拜访日期(至)",
                                            prop: "visitEndDate",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "value-format": "yyyy-MM-dd",
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.visitEndDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "visitEndDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.visitEndDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.queryData(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryFormThis },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableList",
          attrs: {
            data: _vm.tableList,
            border: "",
            "max-height": "450",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              fixed: "",
              "min-width": "50",
              label: _vm.$t("visitPlan.SerialNumber"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "msvNo",
              fixed: "",
              label: "MSV 单据编号",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.toReportDetail(scope.row.ttMsvReportId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.msvNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "year",
              label: _vm.$t("visitPlan.Year"),
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "type",
              label: _vm.$t("visitPlan.Type"),
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "category",
              label: _vm.$t("visitPlan.Category"),
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "plantName",
              label: "工厂",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "statusI18n",
              label: "报告状态",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "visitBeginDate",
              label: "拜访日期",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.visitBeginDate,
                          "YYYY-MM-DD"
                        )
                      ) +
                        "——" +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.visitEndDate,
                            "YYYY-MM-DD"
                          )
                        )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "mgtRecap",
              label: "拜访总结",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "msvResultI18n",
              label: "拜访反馈结果",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "creater",
              "min-width": "140",
              label: _vm.$t("visitPlan.CreateUser"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "createDate",
              label: _vm.$t("visitPlan.CreateDate"),
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.createDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.DestroyIncomeStatistics == true
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: {
                  multipleSelectionFlag: true,
                  categoryLevel1Name: _vm.categoryLevel1Name,
                  categoryLevel2Name: _vm.categoryLevel2Name,
                },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showUserDialog, width: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.showUserDialog = $event
            },
          },
        },
        [_c("PickupUser", { on: { input: _vm.selectUserData } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }